import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../../images/Logo_Aman-Mart-1.png';
import { Button, IconButton } from '../ui';

function Navbar() {
  const [open, setOpen] = useState(false);
  const menuRef = useRef(null);

  // close menu when clicking outside
  useEffect(() => {
    function handleDocClick(e) {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setOpen(false);
      }
    }
    document.addEventListener('click', handleDocClick);
    return () => document.removeEventListener('click', handleDocClick);
  }, []);

  const location = useLocation();

  const navLinks = [
    { to: '/', label: 'Home' },
    { to: '/tentang-kami', label: 'Tentang Kami' },
    { to: '/kategori', label: 'Kategori' },
    { to: '/lokasi', label: 'Lokasi' },
  ];

  const navLinkClass =
    'text-am-text-900 font-semibold font-display transition-colors hover:text-am-accent focus:outline-none focus:ring-2 focus:ring-am-accent focus:ring-offset-2 rounded px-3 py-2';

  const isActive = (to) => {
    if (to === '/') return location.pathname === '/';
    if (to === '/tentang-kami') return location.pathname === '/tentang-kami';
    if (to === '/kategori') return location.pathname.startsWith('/kategori');
    if (to === '/lokasi') return location.pathname === '/lokasi';
    return false;
  };

  return (
    <header className="bg-white/95 backdrop-blur-sm sticky top-0 z-50 border-b border-am-green-100 shadow-sm">
      <div className="max-w-6xl mx-auto flex items-center justify-between gap-4 py-4 px-4 md:px-6 relative min-h-[64px]">
        {/* logo */}
        <Link to="/" className="flex items-center shrink-0">
          <img src={logo} alt="Aman Mart" className="h-9 w-auto" />
        </Link>

        {/* desktop nav */}
        <nav className="hidden md:flex flex-1 justify-center gap-2" aria-label="Navigasi utama">
          {navLinks.map(({ to, label }) => (
            <Link
              key={to}
              to={to}
              className={`${navLinkClass} ${isActive(to) ? 'text-am-accent' : ''}`}
            >
              {label}
            </Link>
          ))}
        </nav>

        {/* desktop CTA */}
        <div className="hidden md:flex shrink-0">
          <Button variant="primary" size="md">Contact Now</Button>
        </div>

        {/* mobile: toggle + dropdown */}
        <div className="md:hidden shrink-0" ref={menuRef}>
          <IconButton
            variant="ghost"
            size="md"
            className="text-2xl"
            aria-label="Toggle menu"
            aria-expanded={open}
            onClick={() => setOpen((s) => !s)}
          >
            {open ? '✕' : '☰'}
          </IconButton>

          {open && (
            <div className="absolute right-4 top-full mt-2 w-56 bg-white rounded-xl shadow-lg border border-am-green-50 z-50 overflow-hidden">
              <nav className="flex flex-col p-2">
                {navLinks.map(({ to, label }) => (
                  <Link
                    key={to}
                    to={to}
                    className="px-3 py-2.5 rounded-lg text-am-text-900 font-medium hover:bg-am-green-50 transition-colors"
                    onClick={() => setOpen(false)}
                  >
                    {label}
                  </Link>
                ))}
                <div className="mt-2 pt-2 border-t border-am-green-100 px-2">
                  <Button variant="primary" size="md" fullWidth>Contact Now</Button>
                </div>
              </nav>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}

export default Navbar;
